import type { KambiBetOfferCategory, KambiSportName } from '@mobi/api-types/kambi'
import { simpleFetchWithLogging } from '../simpleFetchWithLogging'

export function getPreMatchCategoryForSport(sport: KambiSportName) {
  return simpleFetchWithLogging<KambiCategoryResponse>(
    `${window._kc.apiOfferingBaseUrl}category/pre_match_event,selected_pre_match/sport/${sport}?lang=en_AU&market=AU`
  )
}

// =====
// Types
// =====

type KambiCategoryResponse = {
  categoryGroups: {
    categories: KambiBetOfferCategory[]
    categoryGroupName: string
  }[]
}
